// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","buttonWrapper":"Card_buttonWrapper__NS6JZ","icon":"Card_icon__0D7+y","button":"Card_button__hEwJW","active":"Card_active__BqLM7"};